import types from './mutations-types';

const mutations = {
  // ================================================= Old
  [types.SET_CHARTS_BAR](state, payload) {
    state.barCharts.series = payload.series;
    state.barCharts.info = payload.info;
  },
  [types.SET_VERTICAL_COLUMNS](state, payload) {
    state.verticalColumns.series = payload.series;
    state.verticalColumns.info = payload.info;
  },
  [types.SET_INVITES](state, payload) {
    state.dashboardBar.invites = payload;
  },
  [types.SET_ANSWERS](state, payload) {
    state.dashboardBar.answers = payload;
  },
  [types.SET_CLIENTS](state, payload) {
    state.dashboardBar.clients = payload;
  },
  [types.SET_ANSWERS_BY_PHONE](state, payload) {
    state.answersByPhone = {
      ...payload,
    };
  },
  [types.SET_ANSWERS_BY_EMAIL](state, payload) {
    state.answersByEmail = {
      ...payload,
    };
  },
  [types.SET_ANSWERS_BY_MANUAL](state, payload) {
    state.answersByManual = {
      ...payload,
    };
  },
  [types.SET_NPS_BY_DATE](state, payload) {
    state.npsByDate = payload.answers;
  },
  [types.SET_REPORTS_BASIC_COLUMNS](state, payload) {
    state.reports.basicColumn = payload;
  },
  [types.SET_ASSESSMENTS](state, payload) {
    state.reports.assessments = payload;
  },
  [types.SET_CATEGORIES](state, payload) {
    state.reports.categories = payload;
  },

  // [types.SET_RANKINGS](state, payload) {
  //   state.reports.rankings = {
  //     ...state.reports.rankings,
  //     ...{ reviews: payload },
  //   };
  // },
  [types.SET_CSAT](state, payload) {
    state.reports.rankings = {
      ...state.reports.rankings,
      ...{ csat: payload },
    };
  },
  [types.SET_REVIEWS](state, payload) {
    state.reports.rankings = {
      ...state.reports.rankings,
      ...{ reviews: payload },
    };
  },
  [types.SET_LIKERT](state, payload) {
    state.reports.rankings = {
      ...state.reports.rankings,
      ...{ likert: payload },
    };
  },
  [types.SET_EMOTION](state, payload) {
    state.reports.rankings = {
      ...state.reports.rankings,
      ...{ emotion: payload },
    };
  },
  [types.SET_LIKEDISLIKE](state, payload) {
    state.reports.rankings = {
      ...state.reports.rankings,
      ...{ likeDislike: payload },
    };
  },
  // ================================================= end Old

  [types.SET_NPS_EVOLUTION](state, payload) {
    state.npsEvolution = payload;
    // state.selectIndicators = payload.indicators;
    // state.npsEvolution = {
    //   categories: ['10-10-2020'],
    //   series: [10],
    //   seriesAccumulated: [100],
    // };
  },
  [types.SET_ANSWERS_EVOLUTION](state, payload) {
    state.answersEvolution = payload;
    // state.npsEvolution = {
    //   categories: ['10-10-2020'],
    //   series: [10],
    //   seriesAccumulated: [100],
    // };
  },
  [types.SET_INVITES_EVOLUTION](state, payload) {
    state.invitesEvolution = payload;
    // state.npsEvolution = {
    //   categories: ['10-10-2020'],
    //   series: [10],
    //   seriesAccumulated: [100],
    // };
  },
  [types.PERCENTAGE_EVOLUTION](state, payload) {
    state.percentageEvolution = payload;
    // state.npsEvolution = {
    //   categories: ['10-10-2020'],
    //   series: [10],
    //   seriesAccumulated: [100],
    // };
  },
  [types.SET_COMPARATIVE_ACTIONS](state, payload) {
    state.ItemsComparativeActions = payload.data;
    state.totalActionList = payload.documents;
  },
  [types.SET_CSAT_DATA](state, payload) {
    state.csatData = payload;
  },
  [types.SET_EMOTION_DATA](state, payload) {
    state.emotionData = payload;
  },
  [types.SET_LIKE_DISLIKE_DATA](state, payload) {
    state.likeDislikeData = payload;
  },
  [types.SET_LIKERT](state, payload) {
    state.likertData = payload;
  },
  [types.SET_REVIEWS](state, payload) {
    state.reviewsData = payload;
  },
  [types.SET_REPORT_CATEGORIES](state, payload) {
    state.reportCategories = payload;
  },
  [types.SET_REPORT_TAGS](state, payload) {
    state.reportTags = payload;
  },
  [types.SET_INDICATORS](state, payload) {
    state.reportNpsIndicators = payload;
  },
  [types.SET_REPORTS_EMOTIONS](state, payload) {
    state.reportsEmotions = payload;
  },
  [types.SET_WORDCLOUD](state, payload) {
    state.wordcloud = payload;
  },
  [types.SET_REQUEST_PARAMS](state, payload) {
    state.requestParams = payload;
  },
  [types.SET_FILTER_RANKINGS](state, payload) {
    state.filterRankings = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/charts/mutations.js